import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import PrivateRoute from '../../components/src/PrivateRoute.web';
import withSnackBar from '../../components/src/withSnackBar.Web';
import Login from '../../blocks/LandingPage2/src/Auth/Login.web';
import SignUp from '../../blocks/LandingPage2/src/Auth/SignUp.web';
import ForgotPassword from '../../blocks/LandingPage2/src/Auth/ForgotPassword.web';
import ForgotPasswordOTP from '../../blocks/LandingPage2/src/Auth/ForgotPasswordOTP.web';
import CodeVerified from '../../blocks/LandingPage2/src/Auth/CodeVerified.web';
import SetNewPassword from '../../blocks/LandingPage2/src/Auth/SetNewPassword.web';
import TermsAndConditions from '../../blocks/LandingPage2/src/Auth/TermsAndConditions.web';
import PrivacyPolicy from '../../blocks/LandingPage2/src/Auth/PrivacyPolicy.web';
import SurveyStepper from '../../blocks/LandingPage2/src/cfsSurvey/SurveySteper.web';
import SurveyLandingPage from '../../blocks/LandingPage2/src/cfsSurvey/SurveylandingPage.web';
import NewUserDashboard from '../../blocks/LandingPage2/src/NewUserDashboard';
import OnBoardingSurveyLandingPage from '../../blocks/LandingPage2/src/onBoardingSurvey/OnBoardingSurveyLandingPage.web';
import OnBoardingSurvey from '../../blocks/LandingPage2/src/onBoardingSurvey/onBoardingSurvey.web';
import RoadmapPackageSelectionByClient  from "../../blocks/LandingPage2/src/roadmap/RoadmapPackageSelectionByClient.web";
import AdminPrivateRoute from '../../components/src/AdminPrivateRoute.web';
import SessionGuard from '../../components/src/SessionGuard.web';
import { installSessionInterceptors } from '../../framework/src/session/httpInterceptors.web';
import AdminDashboard from '../../blocks/AdminConsole3/src/AdminDashboard.web';
import { ThemeProvider } from '@material-ui/core';
import theme from './theme2';
import StorageProvider from "../../framework/src/StorageProvider.web";
import moment from 'moment';

let isSubscriptionEnded = false;
let hasWarnedSubscriptionEnded = false;
const { fetch: originalFetch } = window;
const isMakeRequest = (config,currentUser)=>{
    let trialPeriodEndTime;
    const currentTime = moment(new Date(new Date().setHours(0,0,0)));
    if(currentUser){
      currentUser = JSON.parse(currentUser);
        let createdAt = new Date(new Date(currentUser?.data?.attributes?.created_at).setHours(23));
        trialPeriodEndTime = moment(createdAt).add(14,'days');
    }
    let trialPeriod = trialPeriodEndTime?.diff(currentTime,'days');
    let canMakeARequest = false;
    let msg = '';
    if(!config?.headers?.token){
      canMakeARequest = true;
    }
    
    if(!canMakeARequest && config?.headers?.skipSubscriptionCheck){
      canMakeARequest = true; 
    }
    if(!canMakeARequest && trialPeriodEndTime && (trialPeriod > 0 || currentUser?.data?.attributes?.current_subscription?.data.length > 0 && currentUser?.data?.attributes?.current_subscription?.data[0].attributes.subscription_status == 'active')){
      canMakeARequest = true;
    }else {
      msg = 'Your trial period has been ended,please buy a subscription';
    }
    return {canMakeARequest,msg}
}
// Callers expect a Response. Handing them undefined makes response.json()
// throw, and the resulting error message is dropped by all but 3 of the 49
// controllers, which leaves the screen blank with no explanation at all.
const subscriptionBlockedResponse = msg =>
  new Response(JSON.stringify({ errors: [{ subscription: msg }] }), {
    status: 402,
    headers: { 'Content-Type': 'application/json' }
  });

window.fetch = async (...args) => {
    let [resource, config ] = args;
    let currentUser = await StorageProvider?.get('currentUser');
    const {canMakeARequest,msg} = isMakeRequest(config,currentUser);
    if(canMakeARequest){
      return await originalFetch(resource, config);
    }

    // The toast used to be skipped on /home/dashboard, so a blocked user
    // already sitting there got no feedback whatsoever. It is guarded on its
    // own flag: sharing the redirect flag would let a block on the dashboard
    // consume it and leave every later screen unguarded.
    if(!hasWarnedSubscriptionEnded){
      hasWarnedSubscriptionEnded = true;
      window?.showToast?.({type:'error',message:msg});
    }

    if(window.location.pathname != '/home/dashboard' && !isSubscriptionEnded){
      isSubscriptionEnded = true;
      window.location.href = '/home/dashboard';
    }
    return subscriptionBlockedResponse(msg);
};

installSessionInterceptors();

class RouteConfig extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute path="/home">
          <SessionGuard>
            <ThemeProvider theme={theme}>
              <NewUserDashboard />
            </ThemeProvider>
          </SessionGuard>
        </PrivateRoute>
        <AdminPrivateRoute path="/adminDashboard">
          <SessionGuard>
            <AdminDashboard />
          </SessionGuard>
        </AdminPrivateRoute>
        
        <Route exact path="/">
          <ThemeProvider theme={theme}>
            <Login />
          </ThemeProvider>
        </Route>
        <Route exact path="/signup">
          <ThemeProvider theme={theme}>
            <SignUp />
          </ThemeProvider>
        </Route>
        <Route exact path="/termsAndConditions">
          <ThemeProvider theme={theme}>
            <TermsAndConditions />
          </ThemeProvider>
        </Route>
        <Route exact path="/privacyPolicy">
          <ThemeProvider theme={theme}>
            <PrivacyPolicy />
          </ThemeProvider>
        </Route>
        <Route exact path="/surveyLandingPage">
          <ThemeProvider theme={theme}>
            <SurveyLandingPage />
          </ThemeProvider>
        </Route>
        <Route exact path="/startSurveySteps">
          <ThemeProvider theme={theme}>
            <SurveyStepper />
          </ThemeProvider>
        </Route>
        <Route exact path="/onboardingSurveyLandingPage">
          <ThemeProvider theme={theme}>
            <OnBoardingSurvey />
          </ThemeProvider>
        </Route>
        <Route exact path="/onboardingSurvey">
          <ThemeProvider theme={theme}>
            <OnBoardingSurveyLandingPage />
          </ThemeProvider>
        </Route>

        {/* phase 2 routes */}

        <Route exact path="/forgotPassword">
          <ThemeProvider theme={theme}>
            <ForgotPassword />
          </ThemeProvider>
        </Route>
        <Route exact path="/forgotPasswordOtp">
          <ThemeProvider theme={theme}>
            <ForgotPasswordOTP />
          </ThemeProvider>
        </Route>

        <Route exact path="/codeVerified">
          <ThemeProvider theme={theme}>
            <CodeVerified title="Code Verified!" />
          </ThemeProvider>
        </Route>

        <Route exact path="/setNewPassword">
          <ThemeProvider theme={theme}>
            <SetNewPassword />
          </ThemeProvider>
        </Route>

        <Route exact path="/passwordResetSuccessfully">
          <ThemeProvider theme={theme}>
            <CodeVerified title="Password Reset Successfully!" />
          </ThemeProvider>
        </Route>
        <Route exact path="/roadmapPackageSelectionByClient">
          <ThemeProvider theme={theme}>
            <RoadmapPackageSelectionByClient />
          </ThemeProvider>
        </Route>
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>
    );
  }
}
export default withSnackBar(RouteConfig);